import { ref, computed } from "vue"

// The confirmation dialog store, a replacement for window.confirm. The `<Confirm>` component that
// renders it lives in components/Confirm.vue and is mounted once by App.vue.
const _state = ref(null) // { title, message, confirmText, variant, resolve }

const useConfirm = () => {
  return {
    state: computed(() => _state.value),
  }
}

/**
 * Shows the confirmation dialog, resolves to true when confirmed, false when closed.
 * @param {string | { message: string, title?: string, confirmText?: string, variant?: string }} options
 * @returns {Promise<boolean>}
 */
const confirmAsync = (options) => {
  const o = typeof options === "string" ? { message: options } : options
  // a dialog still open is answered with "no"
  _state.value?.resolve(false)
  return new Promise((resolve) => {
    _state.value = {
      title: o.title || "Potrditev",
      message: o.message,
      confirmText: o.confirmText || "Potrdi",
      variant: o.variant || "primary",
      resolve,
    }
  })
}

const answer = (confirmed) => {
  const current = _state.value
  _state.value = null
  current?.resolve(confirmed)
}

export { useConfirm, confirmAsync, answer }
